// extracted by mini-css-extract-plugin
module.exports = {"about-card":"About_about-card__94aUG","title":"About_title__3VZ4U","intro":"About_intro__JgOfn","contact":"About_contact__1b96_","item":"About_item__3quNQ"};